export const community = () => ({
  西区: [
    "爱群社区",
    "板樟岭社区",
    "德惠社区",
    "海惠社区",
    "锦惠社区",
    "蓝岸社区",
    "龙光社区",
    "美韵社区",
    "南岸社区",
    "沙田社区",
    "响水社区",
    "新荷社区",
    "新惠社区",
    "永盛社区"
  ],
  澳头: [
    "海滨社区",
    "红树林社区",
    "金湾社区",
    "桥东社区",
    "桥西社区",
    "沙田社区",
    "新澳社区",
    "兴港社区",
    "中兴社区"
  ],
  霞涌: ["东兴社区", "海韵社区", "小径湾社区"]
});
export const allStreets = () => [
  { label: "澳 头", value: "澳头" },
  { label: "西 区", value: "西区" },
  { label: "霞 涌", value: "霞涌" }
];
/*
 * 函数getOrDestroy参数说明：
 * 1.flag 功能选择位：flag == 0（或为false）销毁cookie；flag == 1（或为true）获取cookie值；
 * 2.name cookie名：函数根据name进行搜索，搜索成功之后根据flag进行获取cookie值或销毁cookie。
 */
export const getOrDestroy = (name, flag) => {
  let arr = document.cookie.split(";");
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].indexOf(name) != -1) {
      if (flag) {
        return arr[i].split("=")[1];
      } else {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
    }
  }
};

/*
 * 函数createCookie参数说明：
 * 创建一个cookie：
 * name：cookie名；
 * val：cookie值；
 * type：cookie生存时间类型；
 * num：cookie的生存时间值；
 */
export const createCookie = (name, val, type, num) => {
  let setTime = new Date();
  switch (type) {
    case "sec":
      setTime.setSeconds(setTime.getSeconds() + num);
      break; //设置秒
    case "min":
      setTime.setMinutes(setTime.getMinutes() + num);
      break; //设置分
    case "hour":
      setTime.setHours(setTime.getHours() + num);
      break; //设置时
    case "day":
      setTime.setDate(setTime.getDate() + num);
      break; //设置日
    case "month":
      setTime.setMonth(setTime.getMonth() + num);
      break; //设置月
    case "year":
      setTime.setFullYear(setTime.getFullYear() + num);
      break; //设置年
    default:
      break;
  }
  document.cookie = name + "=" + val + "; expires=" + setTime.toGMTString();
};



// WEBPACK FOOTER //
// ./src/utils/index.js